<template>
  <div class="download-page">
    <div class="logo-container">
      <img :src="info.logo" class="logo" />
      <span class="app-main-name">{{ info.appName }}</span>
      <span class="app-vice-name" v-if="mechanCode == '260580000000800'">圆百万年薪梦，只差这一步！<br />点击下载，开启财富之旅！</span>
    </div>
    <div class="btn-download-container" @click="downloadApp">
      <span>立即下载</span>
    </div>
    <div class="footer-container">
      <span class="name">{{ info.companyName }}</span>
      <div class="time-version">
        <span>应用更新时间：{{ info.updateTime | timeSub(10) }}</span>
        <span class="version">版本号：{{ info.version }}</span>
      </div>
    </div>
    <!-- 引导图 -->
    <div class="download-info" v-if="showYindao"></div>
  </div>
</template>
<script>
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data() {
    return {
      showYindao: false,
      mechanCode: '',
      info: {}
    };
  },
  mounted() {
    if (this.$route.params.mechanCode) {
      this.mechanCode = this.$route.params.mechanCode;
    } else if (location.host == 'okbao.wts999.com' || location.host == 'h5-okbao.wts999.com') {
      this.mechanCode = '260580000000800';
    } else if (location.host == 'txokbao.wts999.com' || location.host == 'h5-txokbao.wts999.com') {
      this.mechanCode = 'txokb';
    }
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$http({
        type: 'GET',
        url: '/app/getAppInfo',
        data: {
          mechanCode: this.mechanCode
        }
      }).then(res => {
        const data = res.data;
        document.getElementById('webIcon').href = data.logo;
        this.info = data;
        const shareData = {
          title: data.appName + 'APP下载',
          logo: data.logo,
          content: '保险数字化展业APP，快捷使用计划书、产品对比、保单托管、访客管理等全栈式展业工具。',
          link: location.href
        };
        window.setTimeout(() => {
          document.title = data.appName + 'APP下载';
        }, 100);
        this.$weixin.share(shareData);
      });
    },
    downloadApp() {
      if (this.$tools.isWeiXin()) {
        this.showYindao = true;
      } else if (this.$tools.ios) {
        this.jump(this.info.iOSDownloadUrl);
      } else {
        this.jump(this.info.andriodDownloadUrl);
      }
    },
    jump(url) {
      if (!url) {
        this.$notice.alert('应用审核上架中，敬请期待');
        return;
      }
      location.href = url;
    }
  }
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
